var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-empty',{attrs:{"description":_vm.description,"image":_vm.empty,"image-size":_vm.size}})
}
var staticRenderFns = []

export { render, staticRenderFns }